import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import DashboardLayout from '../../components/common/DashboardLayout';
import AdminNav from '../../components/admin/AdminNav';
import * as affiliateService from '../../services/adminAffiliate.service';
import { PartnerSection } from '../dashboard/AffiliateDashboard';

/**
 * Jenn, 2026-09-11: "I can't answer her questions... none of this is
 * functional for me as an administrator" — this page shows Team365 the
 * real self-serve dashboard an affiliate sees, without needing their login
 * or a magic link. It renders through PartnerSection, the exact same
 * component the affiliate's own /affiliate/me page uses — not a rebuild,
 * so it can never drift from what they actually see.
 */
export default function AdminAffiliatePreview() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    affiliateService.getPreviewDashboard(id)
      .then(setData)
      .catch(err => setError(err.response?.data?.error || 'Could not load this preview.'));
  }, [id]);

  return (
    <DashboardLayout>
      <div className="max-w-4xl mx-auto">
        <AdminNav />
        <Link to={`/admin/affiliates/${id}`} className="text-xs text-gray-400 hover:text-reset-terracotta">&larr; Back to affiliate</Link>

        <div className="bg-reset-brownDeep text-reset-cream text-sm rounded-2xl px-5 py-3 my-4 flex items-center justify-between flex-wrap gap-2">
          <span>Previewing exactly what this affiliate sees on their own dashboard — read-only, nothing here can be edited from this view.</span>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-4 text-sm">{error}</div>
        )}

        {!data && !error && <p className="text-sm text-gray-400">Loading…</p>}

        {data && data.dashboards.map((d, i) => (
          <PartnerSection key={d.partner.id} {...d} isLast={i === data.dashboards.length - 1} />
        ))}
      </div>
    </DashboardLayout>
  );
}
